import { client } from "../utils";
    
export const getSlabStock = async (slabid,material)=>
        {
           if (slabid==''){
            return await client('/api/checks-avail',{headers:{material:material}})
           }
           else {return await client('/api/checks-avail',{headers:{material:material,slab:slabid}})}
        }
export const RedirectToLogIn=()=>{
   window.location.href='/';
   }
export function roundOff(value, decimals) {
      return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
    }





